import { makeStyles } from "@material-ui/styles";

const sectionDefinitionsStyles = makeStyles((theme) => ({
	// The icon sits beside the section heading, so it is nudged back to the
	// heading's baseline rather than the row's centre.
	trigger: {
		marginLeft: theme.spacing(0.5),
		padding: theme.spacing(0.5)
	},
	title: {
		paddingRight: theme.spacing(5)
	},
	close: {
		position: "absolute",
		right: theme.spacing(1),
		top: theme.spacing(1)
	},
	row: {
		display: "grid",
		gridTemplateColumns: "minmax(170px, 38%) 1fr",
		gap: theme.spacing(3),
		padding: theme.spacing(1.5, 0),
		"&:not(:last-child)": {
			borderBottom: `1px solid ${theme.palette.divider}`
		}
	},
	// Phone width: a two-column definition list stops being readable well
	// before the dialog runs out of room, so the value stacks under its name.
	[theme.breakpoints.down("xs")]: {
		row: {
			gridTemplateColumns: "1fr",
			gap: theme.spacing(0.5)
		}
	},
	value: {
		marginTop: theme.spacing(0.25),
		fontWeight: 500,
		color: theme.palette.text.primary,
		wordBreak: "break-word"
	},
	// The setting's name is the quieter half of the pair: it labels the value.
	term: {
		color: theme.palette.text.secondary
	}
}));

export default sectionDefinitionsStyles;
